import goToSearch from './searchMenu'

document.addEventListener('DOMContentLoaded', () => {
  const el = document.querySelector('[href="#searchinput"]')

  if (!el) return

  el.addEventListener('click', () => {
    goToSearch()
  })

  const elements = document.querySelectorAll('.menu-accessibility a')
  elements.forEach((element) => {
    element.addEventListener('click', () => {
      window.dataLayer.push({
        event: 'navigation',
        section: 'menu-acessibilidade',
        name: element.getAttribute('aria-label')
      })
    })
  })
})

document.addEventListener('DOMContentLoaded', () => {
  let contrastMode = getCookie('contrastMode')
  if (contrastMode) {
    document.body.classList.add('contrast-mode')
  }

  const elContrast = document.getElementById('contrastmode')

  if (!elContrast) {
    console.warn('Could not find Contrast Element Button')
    return
  }

  elContrast.addEventListener('click', (e) => {
    e.preventDefault()
    contrastMode = !contrastMode
    setCookie('contrastMode', contrastMode, 1)

    if (contrastMode) {
      document.body.classList.add('contrast-mode')
    } else {
      document.body.classList.remove('contrast-mode')
    }
  })
})

document.addEventListener('DOMContentLoaded', () => {
  const baseFontSize = parseInt(getComputedStyle(document.documentElement, null).getPropertyValue('font-size'), 10)
  let fontSizeLevel = getCookie('fontSizeLevel')
  if (fontSizeLevel) {
    document.documentElement.style.fontSize = `${baseFontSize + (2 * fontSizeLevel)}px`
  } else {
    fontSizeLevel = 0
  }

  const elIncrease = document.getElementById('increasefontsize')
  const elDecrease = document.getElementById('decreasefontsize')
  if (!elIncrease || !elDecrease) return

  elIncrease.addEventListener('click', (e) => {
    e.preventDefault()
    if (fontSizeLevel < 3) {
      fontSizeLevel++
      document.documentElement.style.fontSize = `${baseFontSize + (2 * fontSizeLevel)}px`
      setCookie('fontSizeLevel', fontSizeLevel, 1)

      document.querySelectorAll('.dropdown__title').forEach(el => {
        el.style.padding = '0'
      })
      document.querySelectorAll('.header--buttons').forEach(el => {
        el.style.gap = '0.2rem'
      })
    }
  })
  elDecrease.addEventListener('click', (e) => {
    e.preventDefault()
    if (fontSizeLevel > 0) {
      fontSizeLevel--
      document.documentElement.style.fontSize = `${baseFontSize + (2 * fontSizeLevel)}px`
      setCookie('fontSizeLevel', fontSizeLevel, 1)

      if (fontSizeLevel === 0) {
        document.querySelectorAll('.dropdown__title').forEach(el => {
          el.style.padding = ''
        })
        document.querySelectorAll('.header--buttons').forEach(el => {
          el.style.gap = ''
        })
      }
    }
  })
})

function setCookie(name, value, days) {
  let expires = ''
  if (days) {
    const date = new Date()
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000))
    expires = `; expires=${date.toUTCString()}`
  }
  document.cookie = `${name}=${value || ''}${expires}; path=/`
}
function getCookie(name) {
  const nameEQ = `${name}=`
  const ca = document.cookie.split(';')
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i]
    while (c.charAt(0) === ' ') c = c.substring(1, c.length)
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length)
  }
  return null
}
